/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentStatus } from './TournamentStatus';
import {
    TournamentStatusFromJSON,
    TournamentStatusFromJSONTyped,
    TournamentStatusToJSON,
    TournamentStatusToJSONTyped,
} from './TournamentStatus';

/**
 * Team info with tournament reference in user context
 * @export
 * @interface UserTeamReference
 */
export interface UserTeamReference {
    /**
     * 
     * @type {string}
     * @memberof UserTeamReference
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTeamReference
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTeamReference
     */
    teamStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTeamReference
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTeamReference
     */
    tournamentName?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserTeamReference
     */
    tournamentDate?: Date;
    /**
     * 
     * @type {TournamentStatus}
     * @memberof UserTeamReference
     */
    tournamentStatus?: TournamentStatus;
    /**
     * 
     * @type {string}
     * @memberof UserTeamReference
     */
    categoryName?: string;
    /**
     * 
     * @type {number}
     * @memberof UserTeamReference
     */
    matchesPlayed?: number;
    /**
     * 
     * @type {Date}
     * @memberof UserTeamReference
     */
    registrationDate?: Date;
}



/**
 * Check if a given object implements the UserTeamReference interface.
 */
export function instanceOfUserTeamReference(value: object): value is UserTeamReference {
    return true;
}

export function UserTeamReferenceFromJSON(json: any): UserTeamReference {
    return UserTeamReferenceFromJSONTyped(json, false);
}

export function UserTeamReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTeamReference {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['team_id'] == null ? undefined : json['team_id'],
        'teamName': json['team_name'] == null ? undefined : json['team_name'],
        'teamStatus': json['team_status'] == null ? undefined : json['team_status'],
        'tournamentId': json['tournament_id'] == null ? undefined : json['tournament_id'],
        'tournamentName': json['tournament_name'] == null ? undefined : json['tournament_name'],
        'tournamentDate': json['tournament_date'] == null ? undefined : (new Date(json['tournament_date'])),
        'tournamentStatus': json['tournament_status'] == null ? undefined : TournamentStatusFromJSON(json['tournament_status']),
        'categoryName': json['category_name'] == null ? undefined : json['category_name'],
        'matchesPlayed': json['matches_played'] == null ? undefined : json['matches_played'],
        'registrationDate': json['registration_date'] == null ? undefined : (new Date(json['registration_date'])),
    };
}

export function UserTeamReferenceToJSON(json: any): UserTeamReference {
    return UserTeamReferenceToJSONTyped(json, false);
}

export function UserTeamReferenceToJSONTyped(value?: UserTeamReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team_id': value['teamId'],
        'team_name': value['teamName'],
        'team_status': value['teamStatus'],
        'tournament_id': value['tournamentId'],
        'tournament_name': value['tournamentName'],
        'tournament_date': value['tournamentDate'] == null ? value['tournamentDate'] : value['tournamentDate'].toISOString().substring(0,10),
        'tournament_status': TournamentStatusToJSON(value['tournamentStatus']),
        'category_name': value['categoryName'],
        'matches_played': value['matchesPlayed'],
        'registration_date': value['registrationDate'] == null ? value['registrationDate'] : value['registrationDate'].toISOString(),
    };
}

